module.exports = __webpack_public_path__ + "a17d279f/img/note-edit-icon.acae1669.svg";